import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapper = styled.div`
  margin-bottom: ${rem('30px')};
  max-width: ${rem('559px')};
`;

const StyledImage = styled.img`
  height: auto;
  width: 100%;
`;

const ImagesContainer = styled.div`
  display: flex;
  width: 100%;
`;

const ImageLink = styled.a`
  flex: 1; /* Ocupa 50% del ancho total */
  display: block;
`;

const VideoThumbnail = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export {
  StyledWrapper,
  StyledImage,
  ImagesContainer,
  ImageLink,
  VideoThumbnail
};
